import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TableRow from '../../table/TableRow';
import { t } from 'i18next';

const StyledTableBody = styled.tbody`
    width: 100%;
`;

const transferRows = ({ information }) => {
    return (
        <StyledTableBody>
            <TableRow
                label={ t('confirmation:bookingInformation.transfer.destinationArrivalDate') }
                value={ information.destinationArrivalDate.toLocaleString() }
            />

            <TableRow
                label={ t('confirmation:bookingInformation.transfer.originAddress') }
                value={ information.originAddress }
            />

            <TableRow
                label={ t('confirmation:bookingInformation.transfer.destinationAddress') }
                value={ information.destinationAddress }
            />

            <TableRow
                label={ t('confirmation:bookingInformation.common.numberOfPersons') }
                value={ information.numberOfPersons }
            />
        </StyledTableBody>
    );
}

transferRows.propTypes = {
    information: PropTypes.shape({
        destinationAddress: PropTypes.string.isRequired,
        numberOfPersons: PropTypes.string,
        originAddress: PropTypes.string.isRequired,
        tripDateRange: PropTypes.array.isRequired,
    }),
}

export default transferRows;
